import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import { Action, Getter, State, Mutation } from 'vuex-class'

@Component
export default class TrackerHeaderBasic extends Vue {
  @Getter getCurrentOrder: any

  get setTime () {
    const dateOrder = new Date(this.getCurrentOrder.programmed_for)
    const dateCurrent = new Date()
    if (dateOrder > dateCurrent) {
      dateOrder.setMinutes(dateOrder.getMinutes() + 7)
      return {
        start: this.getCurrentOrder.programmed_for,
        end: dateOrder
      }
    } else {
      dateOrder.setMinutes(dateOrder.getMinutes() + this.getSumTime)
      return {
        start: dateOrder,
        end: false
      }
    }
  }

  get getSumTime () {
    return parseFloat(this.getCurrentOrder.commerce.avg_preparation_time) + parseFloat(this.getCurrentOrder.commerce.avg_delivery_time)
  }

}
